import { ITransitionData } from "@barba/core";
import { component } from "picoapp";
import {
  TRANSITION_PRODUCT_VIEW_AFTER,
  TRANSITION_PRODUCT_VIEW_BEFORE,
  TRANSITION_PRODUCT_VIEW_LEAVE,
} from "./Views/constants";
import {
  waveUnderBefore,
  waveUnderLeave,
  updateColors,
} from "../../../scripts/animations";

export const transitionOverlay = component((node) => {
  const transitionWaveElement = node.children[0];

  const transitionBefore = ({ detail }: CustomEvent<ITransitionData>) => {
    waveUnderBefore(detail, node, transitionWaveElement);
  };
  const transitionLeave = ({ detail }: CustomEvent<ITransitionData>) => {
    waveUnderLeave(detail, node, transitionWaveElement);
  };
  const transitionAfter = ({ detail }: CustomEvent<ITransitionData>) => {
    setFlavorColors(detail);
  };

  const setFlavorColors = ({ trigger, next }: ITransitionData) => {
    if (trigger === "back" || trigger === "forward") {
      const activeSwatch = next.container.querySelector<HTMLElement>(
        ".product-swatch--active"
      );

      if (!activeSwatch) return;
      node.style.background = activeSwatch.dataset.colorLight;
      transitionWaveElement.setAttribute(
        "fill",
        `${activeSwatch.dataset.colorLight}`
      );

      updateColors(activeSwatch);
    }
  };

  window.addEventListener(TRANSITION_PRODUCT_VIEW_BEFORE, transitionBefore);
  window.addEventListener(TRANSITION_PRODUCT_VIEW_LEAVE, transitionLeave);
  window.addEventListener(TRANSITION_PRODUCT_VIEW_AFTER, transitionAfter);

  return () => {
    window.removeEventListener(
      TRANSITION_PRODUCT_VIEW_BEFORE,
      transitionBefore
    );
    window.removeEventListener(TRANSITION_PRODUCT_VIEW_LEAVE, transitionLeave);
    window.removeEventListener(TRANSITION_PRODUCT_VIEW_AFTER, transitionAfter);
  };
});
